/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import CostWeightedIcon from "../../../../assets/icons/serviceOverview/IconCosts";
import ServiceWeightedIcon from "../../../../assets/icons/serviceOverview/IconServicewelt";
import AssistanceWeightedIcon from "../../../../assets/icons/serviceOverview/IconAssistantSmile";
import serviceSectionStyle from "./serviceSectionStyle";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import TextContainer from "../../../Container/TextContainer";
import Typography from "@mui/material/Typography";
import GradientPaper from "../../../GradientComponents/GradientPaper";
import { Box } from "@mui/material";
import theme from "../../../../theme/Theme";

type ServiceSectionProps = {
  product?: "divorce" | "generic" | "settlement";
};

export const ServiceSection = ({ product = "divorce" }: ServiceSectionProps) => {
  return (
    <>
      <Container sx={serviceSectionStyle.centered}>
        <Box sx={serviceSectionStyle.scrollToAnchor} id="service">
          {" "}
        </Box>
        <Typography variant={"h2"}>Unser Service: Das Rundum-Sorglos-Paket</Typography>
        <Typography variant={"h3"}>Einfach, schnell und professionell beraten!</Typography>
      </Container>
      <Box>
        <TextContainer sx={serviceSectionStyle.centered}>
          <Grid container>
            <Grid item xs={12}>
              <GradientPaper sx={serviceSectionStyle.paper}>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={4}>
                    <CostWeightedIcon sx={serviceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Transparente Kostenübersicht</Typography>
                    <Typography>Keine versteckten Kosten und nur Mindestgebühren: Wir ermöglichen Ihnen immer den günstigsten Preis!</Typography>
                  </Grid>
                </Grid>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Individueller Servicebereich</Typography>
                    <Typography>
                      {product !== "divorce" && <>Umfassende Informationen, Ihre Angaben und wichtige Dokumente </>}
                      {product === "divorce" && (
                        <>Ihr persönlicher Scheidungsplaner inklusive Tipps und Checklisten, umfassende Informationen und wichtige Dokumente </>
                      )}
                      - Alles sicher an einem Ort und immer griffbereit.
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} sx={serviceSectionStyle.gridItemReversed(theme)}>
                    <ServiceWeightedIcon sx={serviceSectionStyle.icon(theme)} />
                  </Grid>
                </Grid>
                <Grid container sx={serviceSectionStyle.advantageContainer}>
                  <Grid item xs={12} sm={4}>
                    <AssistanceWeightedIcon sx={serviceSectionStyle.icon(theme)} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant={"h4"}>Persönlicher Ansprechpartner</Typography>
                    <p>Ihr persönlicher Ansprechpartner in der Mandantenbetreuung und unsere Anwälte begleiten Sie und helfen jederzeit weiter.</p>
                  </Grid>
                </Grid>
              </GradientPaper>
            </Grid>
          </Grid>
        </TextContainer>
      </Box>
    </>
  );
};

export default ServiceSection;
